class Faq {
  start() {
    const buttonOpen = document.querySelectorAll('.faq-wrapper .faq-block-toggle');
    buttonOpen.forEach((item) => {
      item.addEventListener('click', toggleCollapse);
    });
  }
}

function toggleCollapse(e) {
  const parent = e.currentTarget.closest('.faq-wrapper');
  if (e.currentTarget.classList.contains('faq-block-toggle_close')) {
    parent.querySelector('.faq-content').classList.remove('faq-content_close');
    parent.querySelector('.faq-hidden').style.display = 'none';
    parent.querySelector('.faq-block-toggle').classList.remove('faq-block-toggle_close');
    parent.querySelector('.faq-block-toggle').classList.add('faq-block-toggle_open');
  } else {
    parent.querySelector('.faq-content').classList.add('faq-content_close');
    parent.querySelector('.faq-hidden').style.display = 'block';
    parent.querySelector('.faq-block-toggle').classList.add('faq-block-toggle_close');
    parent.querySelector('.faq-block-toggle').classList.remove('faq-block-toggle_open');
  }
}

module.exports = Faq;
